import { addDays } from 'date-fns'

import { gracePeriodInDays } from '@constants/general'
import {
  CurrentPeriodLimits,
  HubSpotSubscription,
  SubscriptionPlan,
  useMeQuery,
  useOrganizationHubSpotSubscriptionQuery,
} from '@graphQLGenerated'

const useIsPremium = (): {
  isPremium: boolean
  isPayed: boolean
  subscriptionPlan: SubscriptionPlan
  subscriptionGracePeriodEndDate: Date
  hubSpotData?: HubSpotSubscription
  formLimits?: CurrentPeriodLimits | null
  formLimitReached: boolean
  transcriptLimits?: CurrentPeriodLimits | null
  transcriptionLimitReached: boolean
} => {
  const { data } = useMeQuery()

  const { data: hubSpotData } = useOrganizationHubSpotSubscriptionQuery({
    fetchPolicy: 'cache-first',
    skip: window.location.pathname.includes('client-portal'),
  })

  return {
    // premium subscriptionPlan is used to show the EHR components that we are not using anymore.
    isPremium: false, // data?.me?.organization?.subscriptionPlan === SubscriptionPlan.Premium,
    isPayed: data?.me?.organization?.subscriptionPlan !== SubscriptionPlan.FreeTrial,
    subscriptionPlan:
      data?.me?.organization?.subscriptionPlan &&
      data.me.organization.subscriptionPlan !== SubscriptionPlan.Premium
        ? data.me.organization.subscriptionPlan
        : SubscriptionPlan.Standard,
    hubSpotData: hubSpotData?.organizationHubSpotSubscription || undefined,
    subscriptionGracePeriodEndDate: addDays(
      hubSpotData?.organizationHubSpotSubscription?.lastPaymentDate || new Date(),
      gracePeriodInDays,
    ),
    formLimits: data?.me?.organization?.currentPeriodFormLimits,
    formLimitReached:
      typeof data?.me?.organization?.currentPeriodFormLimits?.limit === 'number' &&
      (data?.me?.organization?.currentPeriodFormLimits?.count || 0) >=
        data?.me?.organization?.currentPeriodFormLimits?.limit,
    transcriptLimits: data?.me?.organization?.currentPeriodTranscriptionLimits,
    transcriptionLimitReached:
      typeof data?.me?.organization?.currentPeriodTranscriptionLimits?.limit === 'number' &&
      (data?.me?.organization?.currentPeriodTranscriptionLimits?.count || 0) >=
        data?.me?.organization?.currentPeriodTranscriptionLimits?.limit,
  }
}

export default useIsPremium
